export const PROFILE_GET = "profileGet";
// export const PROFILE_DAYS_OFF_GET = "profileDaysOffGet";
export const PROFILE_UPDATE = "profileUpdate";
export const PROFILE_LOGO_GET = "profileLogoGet";
export const PROFILE_CEP_SEARCH = "profileCepSearch";
// export const PROFILE_LOGO_SAVE = "profileLogoSave";
